import React from 'react';
import { Place } from '@/types';
import { formatPlaceName } from '@/lib/utils';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';

interface PeerJurisdictionCardProps {
  jurisdiction: Place;
  onRemove: () => void;
  isRemoving: boolean;
}

export const PeerJurisdictionCard: React.FC<PeerJurisdictionCardProps> = ({
  jurisdiction,
  onRemove,
  isRemoving
}) => {
  return (
    <motion.div
      layout
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.8 }}
      transition={{ duration: 0.3 }}
      className={`group relative min-h-[80px] border-[1.5px] border-[#CA0079] [border-radius:10px] bg-white text-sm cursor-pointer transition-all duration-300 overflow-hidden ${
        isRemoving ? 'opacity-0 scale-95' : 'opacity-100 scale-100'
      }`}
    >
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="mx-[20px] my-[10px]">
          <span className="transition-opacity group-hover:opacity-0 text-center block text-md">
            {formatPlaceName(jurisdiction.name)}
          </span>
        </div>
      </div>
      <button
        onClick={onRemove}
        className="absolute inset-0 flex items-center justify-center bg-[#ca0079] text-white opacity-0 group-hover:opacity-100 transition-opacity text-xs"
        aria-label={`Remove ${jurisdiction.name}`}
      >
        <X size={14} className="mr-1" />
        Remove This Peer
      </button>
    </motion.div>
  );
};
